import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

import { useAppDispatch, useAppSelector } from "@store/hooks";
import { toastSelector } from "@store/selectors/toast";
import { closeToast } from "@store/slices/toast";

const ToastManager = () => {
	const { anchorOrigin, autoHideDuration, color, message, open, severity } =
		useAppSelector(toastSelector);
	const dispatch = useAppDispatch();

	const handleOnClose = () => {
		dispatch(closeToast());
	};

	return (
		<Snackbar
			open={open}
			autoHideDuration={autoHideDuration}
			anchorOrigin={anchorOrigin}
			onClose={handleOnClose}
		>
			<Alert
				severity={severity}
				onClose={handleOnClose}
				sx={{
					"& svg": {
						fill: "#ffffff",
					},
					backgroundColor: color,
					maxWidth: 280,
				}}
			>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default ToastManager;
